import { PurchaseOrderStatuses } from "@/enums";

export function getPurchaseOrderStatus(document: any): number | undefined {
  if (!document) {
    return undefined;
  }

  const status = document.documentStatus ?? document.status;
  return status !== undefined && status !== null ? Number(status) : undefined;
}

export function isPurchaseOrderStatusChangeLocked(document: any): boolean {
  return (
    getPurchaseOrderStatus(document) === PurchaseOrderStatuses.SentToSupplier
  );
}

export function isPurchaseOrderCanceled(document: any): boolean {
  return getPurchaseOrderStatus(document) === 8;
}
